<template>
  <div>
   <div class="event" v-for="(item, i) in calItems" :key="i">
     <p class="start" v-html="getStart(item)">{{item.start}}</p>
     <p>{{item.summary}}</p>
     
     <p v-if="item.description" v-html="item.description"></p>
     <p class="location" v-if="item.location"><img width="16" height="16" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkAhsRBCmH4+TlAAAA0UlEQVQoz3XRvUoDQRSG4Scu/gSscwsRBPEWUmpnYQqxVRDvQrFI562IIFgLK9pooRCvIaQQU2XFYzPu7kR9p5lzvhcOc4YfVpy6NzNTOrFsgZ5H0ToPeu24UKZgappud5Ya4VAIEztg10QIB41wLYT9uh4K4aoR3oRKt667KmGMNGeOIhOK1E3CEzqOauFYB8/NiIEQ5s709Z2rhDBoP/Q220IIN/mitn1mcWVrcZejTLjwizWvdfxi1R9seBfCh03/sOdLGObf1GZsXemy3foGiMxcFzuU04cAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDItMjdUMTc6MDQ6NDErMDA6MDCaR0qrAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTAyLTI3VDE3OjA0OjQxKzAwOjAw6xryFwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" />
        {{item.location}}</p>
   </div>
   <div class="error" v-if="error.length > 0">{{error}}</div>
   <!-- <button v-on:click="clickButton" v-html="buttonDescription()"></button> -->
   <!-- <button v-on:click="pushNotification()">Notification</button> -->
  </div>
</template>

<script>
import EventBus from '../bus'
export default {
  name: 'start',
  data () {
    return {
      cal_id: 'parker2020.daniel@gmail.com',
      api_key: 'AIzaSyA2oeEEVzakpWKWGmc8vxyIF7wBzlKhuaI',
      calItems: [],
      error: '',
      timer: null,
      timerActiv: false,
      weekday: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      months: [ '', 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ]
    }
  },
  created: function () {
    EventBus.$on('startClick', this.onStartClick)
    Notification.requestPermission(function (status) {
      console.log('Notification permission status:', status)
    })
  },
  mounted: function () {
    this.GetEvents()
  },
  methods: {
    buttonDescription () {
      return (this.timerActiv) ? 'Clear Timer' : 'Set Timer'
    },
    GetEvents () {
      this.error = ''
      this.$http.get('https://www.googleapis.com/calendar/v3/calendars/' + this.cal_id + '/events?key=' + this.api_key + '&maxResults=10&singleEvents=true&orderBy=startTime&timeMin=' + this.getTimeMin()).then(response => {
        this.calItems = response.body.items // .sort((a, b) => new Date(a.start.dateTime) - new Date(b.start.dateTime))
      }, response => {
        this.error = 'FEHLER'
        if (response.status === 422) {
          console.log(response)
        }
      })
    },
    clickButton () {
      if (!this.timerActiv) {
        var self = this
        this.timer = setInterval(function () {
          self.pushNotification()
        }, 10000)
      } else {
        clearInterval(this.timer)
      }
      this.timerActiv = !this.timerActiv
    },
    pushNotification () {
      if (Notification.permission === 'granted') {
        console.log('PUSH NOTIFICATION')
        navigator.serviceWorker.getRegistration().then(function (reg) {
          if (reg) {
            reg.showNotification('Neuer Termin', {
              body: 'Ein neuer Termin steht an!',
              icon: '../../static/img/icons/android-chrome-192x192.png',
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              tag: 'vibration-sample'
            })
          }
        })
      }
    },
    getTimeMin () {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
      var yyyy = today.getFullYear()
      // 2020-02-29T00:00:00Z
      return yyyy + '-' + mm + '-' + dd + 'T00:00:00Z'
    },
    onStartClick () {
      this.GetEvents()
    },
    getStart (item) {
      const d = new Date(item.start.dateTime)
      const dt = d.toLocaleString().replace(',', '').split(' ')
      const date = dt[0].split('.')
      const time = dt[1].split(':')
      return this.weekday[d.getDay()] + ' ' + this.pad_2(date[0]) + '. ' + this.months[date[1]] + ' um ' + time[0] + ':' + time[1] + 'Uhr'
    },
    pad_2 (number) {
      return (number < 10 ? '0' : '') + number
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* @font-face { 
  font-family: "JERSEY"; 
  src: url("../../static/fonts/JerseyM54-aLX9.ttf"); 
} */

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}

.event p{
  margin: 4px 0;
  text-align: left;
}
.event {
  font-size: 0.9rem;
  border-bottom: 1px solid #35495E;
  padding: 10px 0;
}
.error {
  margin: 2px 0;
  text-align: left;
}

button {
  margin: 10px;
}

.start {
  /* font-style: italic; */
  font-weight: bold;
  /* font-family: "JERSEY", "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 2px;
  position: relative; */
}

/* .start span {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
  position: absolute;
  top: 0;
} */

.location {
  display: flex;
  align-items: center;
}

.location img {
  margin-right: 4px;
}



</style>




// WEBPACK FOOTER //
// src/components/Start.vue